module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/calling/no-minutes.svg"